module.exports = __webpack_public_path__ + "img/NH_DU_kit.1461249d.png";